import React from 'react'
import styled from 'styled-components'

const PaddingWrapper = styled.div`
  padding-top: 200px;
`

export default (props) => <PaddingWrapper>{props.children}</PaddingWrapper>
